import { render, staticRenderFns } from "./question.vue?vue&type=template&id=71f9eb16&"
import script from "./question.vue?vue&type=script&lang=js&"
export * from "./question.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71f9eb16')) {
      api.createRecord('71f9eb16', component.options)
    } else {
      api.reload('71f9eb16', component.options)
    }
    module.hot.accept("./question.vue?vue&type=template&id=71f9eb16&", function () {
      api.rerender('71f9eb16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/question.vue"
export default component.exports